function Verified(){
    return(
        <section className="verify-section">
            <h1 className="verify-head">VERIFIED EXPECTS : AT YOUR DOORSTEP</h1>
            <h6 className="verify-comment">Your Home, Our Responsibility.✅ <br /> We Show Up. We Clean Up. 🏠</h6>
           
            <div className="verify-track">
                 <div className="verify-card">
                    <h1 className="card-head">300,000+</h1>
                    <p className="card-comment">Homes Cleaned</p>
                 </div>
                 <div className="verify-card">
                    <h1 className="card-head">210,000+</h1>
                    <p className="card-comment">Hours Saved</p>
                 </div>
                 <div className="verify-card">
                    <h1 className="card-head">2000+</h1>
                    <p className="card-comment">Professional <br />Workers</p>
                 </div>
      </div>   
        </section>
    )
}

export default Verified;